import { API_ENDPOINTS } from '../config/api.config';

async function request(url, options) {
  const res = await fetch(url, options);
  let body = null;
  try {
    body = await res.json();
  } catch (e) {
    body = null;
  }
  if (!res.ok) throw new Error(body?.error || body?.message || `Request failed (${res.status})`);
  return body || {};
}

const jsonOptions = (method, payload) => ({
  method,
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload),
});

/** Worklog dell'utente in un intervallo di date (inclusivo, YYYY-MM-DD). */
export async function fetchWorklogsInRange(userId, dateFrom, dateTo) {
  const params = new URLSearchParams({ user_id: String(userId), date_from: dateFrom, date_to: dateTo });
  const data = await request(`${API_ENDPOINTS.WORKLOGS}?${params}`);
  return (data.worklogs || []).filter((w) => String(w.user_id) === String(userId));
}

export const createWorklog = (payload) => request(API_ENDPOINTS.WORKLOGS, jsonOptions('POST', payload));
export const updateWorklog = (payload) => request(API_ENDPOINTS.WORKLOGS, jsonOptions('PUT', payload));
export const deleteWorklog = (id) => request(`${API_ENDPOINTS.WORKLOGS}?id=${id}`, { method: 'DELETE' });

/** Progetti assegnati all'utente, con cliente e validità dell'assegnazione. */
export async function fetchUserProjects(userId) {
  const data = await request(`${API_ENDPOINTS.PROJECT_USERS}?user_id=${userId}`);
  return (data.user_projects_with_references || []).map((item) => ({
    ...item.project,
    customer: item.customer,
    validity_end_date: item.validity_end_date,
  }));
}

/** Attività (senza FORECAST) ed effort type. */
export async function fetchWorklogOptions() {
  const [act, et] = await Promise.all([request(API_ENDPOINTS.ACTIVITIES), request(API_ENDPOINTS.EFFORT_TYPES)]);
  return {
    activities: (act.activities || []).filter((a) => String(a.name || '').toUpperCase() !== 'FORECAST'),
    effortTypes: et.effort_types || [],
  };
}

/** Id attività abilitate per il progetto (lista vuota = nessuna restrizione). */
export async function fetchAllowedActivityIds(projectId) {
  try {
    const data = await request(`${API_ENDPOINTS.PROJECT_ACTIVITIES}?project_id=${projectId}`);
    return Array.isArray(data.activity_ids) ? data.activity_ids : [];
  } catch (e) {
    return [];
  }
}
